import { useEffect, useState } from "react";

// Extend Navigator interface to include WebKit-specific properties
interface NavigatorStandalone extends Navigator {
    standalone?: boolean;
}

interface UseIsWebviewReturn {
    isWebview: boolean;
    setIsWebview: (value: boolean) => void;
}

const useIsWebview = (): UseIsWebviewReturn => {
    const [isWebview, setIsWebview] = useState<boolean>(false);

    // Check if site is access through web view
    useEffect(() => {
        if (typeof window !== "undefined") {
            const navigator = window.navigator as NavigatorStandalone;
            const standalone = navigator.standalone;
            const userAgent = window.navigator.userAgent.toLowerCase();
            const safari = /safari/.test(userAgent);
            const ios = /iphone|ipod|ipad/.test(userAgent);

            if (ios) {
                if (!standalone && !safari) {
                    // iOS webview
                    setIsWebview(true);
                } else {
                    setIsWebview(false);
                }
            } else {
                if (userAgent.includes("wv")) {
                    // Android webview
                    setIsWebview(true);
                } else {
                    setIsWebview(false);
                }
            }
        }
    }, []);

    return { isWebview, setIsWebview };
};

export default useIsWebview;
